import { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, Table, Divider, Space } from 'antd';

import { backendUrl } from '../../Config';
import { ajaxFetchCall } from '../../services/ApiService';
import { useSearchParams } from "react-router-dom";

import AddEditTransactionForm from "./addEditTransactionForm"
import { useNavigate } from "react-router-dom";

import { getColumns } from './config';
import Worth from "./worth.js"
import { getDateParams, getFilterParams, getPaginationParams, getSorterParams, setQueryParams } from '../../utils/state_query_param_util';
import "./portfolio.css"
import { createTableFilters } from '../../services/TableFilter.js';
export default function Portfolio(props) {
    let navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [dateDefaultValue, setDateDefaultValue] = useState(getDateParams(searchParams))
    const [pagination, setPagination] = useState(getPaginationParams(searchParams))

    const [filters, setFilters] = useState(getFilterParams(searchParams))

    const [sorter, setSorter] = useState(getSorterParams(searchParams))

    const [dataSource, setDataSource] = useState([])
    const [columns, setColumns] = useState(getColumns(filters));

    let initialize = async () => {
        await getUserTransactions()
        await getUniqueInvestedBy()
    }

    let getUniqueInvestedBy = async () => {
        let uniqueInvestedBy = await ajaxFetchCall(backendUrl + "/user/distinct/" + "usertransactions/" + "investedBy")
        let tempCols = [...columns]
        tempCols[7]["filters"] = createTableFilters(uniqueInvestedBy.response)
        setColumns(tempCols)
    }


    useEffect(async () => {
        initialize()
    }, [])

    useEffect(() => {
        initialize()
        setQueryParams(setSearchParams, filters, pagination, sorter, dateDefaultValue)
    }, [dateDefaultValue, filters, sorter])


    const getUserTransactions = async () => {
        let investedBy = ""
        if (filters["investedBy"]) {
            investedBy = "&investedBy=" + filters["investedBy"]
        }
        let data = await ajaxFetchCall(backendUrl + "/user/transaction?" + investedBy)
        setDataSource(data['response'])
    }



    const onFinish = async (values) => {
        if (values.nav) {
            if (values['date']) {
                values['date'] = values['date'].startOf('day')
            }
            let data = await ajaxFetchCall(backendUrl + "/user/transaction", {
                method: "POST",
                body: JSON.stringify(values)
            })
            setIsModalVisible(false)
            initialize()
        }
    };

    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    }
    const onChange = (pagination, filters, sorter) => {
        setPagination(pagination)
        setFilters(filters)
        let tempCols = [...columns]
        for (let filter in filters) {
            for (let col in tempCols) {
                if (tempCols[col].key == filter) {
                    tempCols[col].filteredValue = filters[filter]
                }
            }
        }
        setColumns(tempCols)
        setSorter(sorter)
    }

    return (
        <div >
            <div className="transaction-wrapper">
                <Worth transactions={dataSource}></Worth>
                <Button type="primary" onClick={showModal}>
                    Add Transaction
                </Button>
            </div>
            <Modal destroyOnClose={true} title="Add Transaction" footer={null} visible={isModalVisible} onCancel={handleCancel} handleCancel={handleCancel}>
                <AddEditTransactionForm onFinish={onFinish}></AddEditTransactionForm>
            </Modal>

            <Table dataSource={dataSource} columns={columns}
                pagination={false}
                onChange={onChange}
                onRow={(record) => ({
                    onClick: () => {
                        navigate("/portfolio/" + record._id)
                    },
                })}
            />

        </div >

    )
}